module.exports = __webpack_public_path__ + "static/img/logo-vida-software.6b41c55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-vida-software.png
// module id = KaMS
// module chunks = 3